import moment from "moment";
import { formatear } from "../funciones/funcionesGenerales";
export class Periodos {
  static evaluacionesPresupuestoReal(reales, escenarios) {
    formatear.momentAbrev();
    const Periodos = [];
    let periodoSeleccionado;
    for(const periodo of reales){
      const fecha = moment(periodo.periodo);

      let periodoAnio = Periodos.find(p => p.anio === fecha.year());

      if (!periodoAnio) {
        periodoAnio = {
          anio: fecha.year(),
          visible: true,
          series: []
        };

        Periodos.push(periodoAnio);
      }

      // Buscar si ya existe ese mes
      let serie = periodoAnio.series.find(s =>
        s.periodo === periodo.periodo
      );

      // Si no existe, crearla
      if (!serie) {
        let nmes = fecha.format('MMM').replace('.', '').toLowerCase();
        let anio = fecha.format('YY');
        serie = {
          idReal: null,
          idPresupuesto: null,
          idInstitucion: null,
          idPlantilla: periodo.plantillaId,
          periodo: periodo.periodo,

          mes: nmes,
          anio: anio,
          visible: true,
          check: false,
          nombre: `${nmes} ${anio}`
        };
        periodoAnio.series.push(serie);
      }

      serie.idReal = periodo.id;
      let grupo = escenarios
        .map(escenario =>
            escenario.find(e => e.periodo === periodo.periodo)
        )
        .filter(Boolean);
      serie.idPresupuesto = grupo;
    }

    Periodos.sort((a, b) => a.anio - b.anio);

    Periodos.forEach(periodo => {
      periodo.series.sort((a, b) =>
        moment(a.periodo).diff(moment(b.periodo))
      );
    });

    const ultimoAnio = Periodos[Periodos.length - 1];

    if (ultimoAnio) {
      periodoSeleccionado = ultimoAnio.series[ultimoAnio.series.length - 1];
      periodoSeleccionado.check = true;
    }

    return {
      periodos: Periodos,
      perSeleccionado: periodoSeleccionado
    };
  }
  static evaluacionesSursales(reales, sucEscenarios) {
    moment.locale('es');
    const Periodos = [];
    let periodoSeleccionado;
    let cont = 0
    const realesBase = Object.values(reales)[0]?.['evaEsce'] ?? [];
    for(const periodo of realesBase){
      const fecha = moment(periodo.periodo);

      let periodoAnio = Periodos.find(p => p.anio === fecha.year());

      if (!periodoAnio) {
        periodoAnio = {
          anio: fecha.year(),
          visible: true,
          series: []
        };

        Periodos.push(periodoAnio);
      }

      // Buscar si ya existe ese mes
      let serie = periodoAnio.series.find(s =>
        s.periodo === periodo.periodo
      );

      // Si no existe, crearla
      if (!serie) {
        let nmes = fecha.format('MMM').replace('.', '').toLowerCase();
        let anio = fecha.format('YY');
        serie = {
          idReal: null,
          idPresupuesto: null,
          idInstitucion: null,
          idPlantilla: periodo.plantillaId,
          periodo: periodo.periodo,

          mes: nmes,
          anio: anio,
          visible: true,
          check: false,
          nombre: `${nmes} ${anio}`
        };
        periodoAnio.series.push(serie);
      }
      const grupoReal = {};
      const grupoPresupuesto = {};
      for (const sucursalId in sucEscenarios) {
        grupoReal[sucursalId] = reales[sucursalId].evaEsce[cont];
        grupoPresupuesto[sucursalId] = [];
        for (const escenario of sucEscenarios[sucursalId].evaEsce) {
          grupoPresupuesto[sucursalId].push(escenario[cont]);
        }
      }
      serie.idReal = grupoReal;
      serie.idPresupuesto = grupoPresupuesto;
      cont++;
    }

    Periodos.sort((a, b) => a.anio - b.anio);

    Periodos.forEach(periodo => {
      periodo.series.sort((a, b) =>
        moment(a.periodo).diff(moment(b.periodo))
      );
    });

    const ultimoAnio = Periodos[Periodos.length - 1];

    if (ultimoAnio) {
      periodoSeleccionado = ultimoAnio.series[ultimoAnio.series.length - 1];
      periodoSeleccionado.check = true;
    }

    return {
      periodos: Periodos,
      perSeleccionado: periodoSeleccionado
    };
  }
}